<script>
	import SvelteMarkdown from "svelte-markdown";

	export let onClose;
	export let text = `# Consent\n\nThis survey is part of an MIT scientific research project. \n\nYour decision to complete this survey is voluntary. If you give us permission by completing the survey, we plan to discuss/publish the results in an academic forum. In any publication, information will be provided in such a way that you cannot be identified. Only members of the research team will have access to the original data set. Before the data is shared outside the research team, any potentially identifying information will be removed. Once identifying data has been removed, the data may be used by the research team, or shared with other researchers, for both related and unrelated research purposes in the future. Your anonymized data may also be made available in online data repositories such as the Open Science Framework, which allow other researchers and interested parties to use the data for further analysis.\n\nThe study involves a hypothetical newsfeed, and therefore contains elements of deception, which will be debriefed at the end. \n\nClicking on the button below indicates that you are at least 18 years of age and agree to complete this survey voluntarily.
`;

	let exp_params = JSON.parse(localStorage.getItem("experiment_parameters"));
	let consent_text = exp_params.filter((i) => i.parameter == "consent")[0]
		.value;
	if (consent_text && consent_text.length > 0) {
		text = decodeURIComponent(consent_text);
	}
</script>

<SvelteMarkdown source={text} options={{ mangle: false }} />

<button on:click|preventDefault={onClose}>Agree and continue</button>

<style>
	button {
		margin: auto;
		margin-bottom: 34px;
		margin-top: 34px;
		display: block;
	}
	@media (max-width: 500px) {
		button {
			margin: auto;
			margin-bottom: 55px;
			margin-top: 34px;
			display: block;
		}
	}
</style>
